import { Controller } from "stimulus"
import { sending_to_upper_chamber, sending_to_lower_chamber, sending_to_both_chambers, sending_to_specific_legislators } from "../../helpers"

export default class extends Controller {
	static targets = [ "sendTo", "delaySending", "allowUserComments", "redirectUser", "additionalEmailType" ]

	connect() {
		// Display the proper fields based on the send to value
		let sendTo = this.sendToTarget.options[this.sendToTarget.selectedIndex].value
		this.showCorrectSendToFields(sendTo)

		// Display the delay setting fields if necessary
		let delaySending = this.delaySendingTarget.checked
		this.showDelaySendingFields(delaySending)

		// Display the user comment settings fields if necessary
		let allowUserComments = this.allowUserCommentsTarget.checked
		this.showUserCommentFields(allowUserComments)

		// Display the redirect settings fields if necessary
		let redirectUser = this.redirectUserTarget.checked
		this.showRedirectionFields(redirectUser)

		// Show the additional emails email parts step if necessary
		this.showAdditionalEmailsEmailPartsStep()
	}

	sendToChanged(event) {
		let selectedValue = event.target.options[event.target.selectedIndex].value
		this.showCorrectSendToFields(selectedValue)
	}

	delaySendingChanged(event) {
		let delaySending = event.target.checked
		this.showDelaySendingFields(delaySending)
	}

	allowUserCommentsChanged(event) {
		let allowUserComments = event.target.checked
		this.showUserCommentFields(allowUserComments)
	}

	redirectSettingsChanged(event) {
		let redirectUser = event.target.checked
		this.showRedirectionFields(redirectUser)
	}

	additionalEmailTypeChanged(event) {
		this.showAdditionalEmailsEmailPartsStep()
	}

	showCorrectSendToFields(value) {
		if (!value) {
			$('.email_advocacy_upper_chamber_legislation_title').hide()
			$('.email_advocacy_lower_chamber_legislation_title').hide()
			$('.email_advocacy_specific_legislator_legislation_title').hide()

			$('.notice').show()

			return;
		}

		if (sending_to_upper_chamber(value)) {
			$('.email_advocacy_upper_chamber_legislation_title').show()
			$('.email_advocacy_lower_chamber_legislation_title').hide()
			$('.email_advocacy_specific_legislator_legislation_title').hide()

			$('#specific-members-email-advocacy').hide()
			$('#auto-members-email-advocacy').show()
			$('.upper-chamber-subject-lines').show()
			$('.lower-chamber-subject-lines').hide()

			$('.notice').hide()
		}

		if (sending_to_lower_chamber(value)) {
			$('.email_advocacy_upper_chamber_legislation_title').hide()
			$('.email_advocacy_lower_chamber_legislation_title').show()
			$('.email_advocacy_specific_legislator_legislation_title').hide()

			$('#specific-members-email-advocacy').hide()
			$('#auto-members-email-advocacy').show()
			$('.upper-chamber-subject-lines').hide()
			$('.lower-chamber-subject-lines').show()

			$('.notice').hide()
		}

		if (sending_to_both_chambers(value)) {
			$('.email_advocacy_upper_chamber_legislation_title').show()
			$('.email_advocacy_lower_chamber_legislation_title').show()
			$('.email_advocacy_specific_legislator_legislation_title').hide()

			$('#specific-members-email-advocacy').hide()
			$('#auto-members-email-advocacy').show()
			$('.upper-chamber-subject-lines').show()
			$('.lower-chamber-subject-lines').show()

			$('.notice').hide()
		}

		if (sending_to_specific_legislators(value)) {
			$('.email_advocacy_upper_chamber_legislation_title').hide()
			$('.email_advocacy_lower_chamber_legislation_title').hide()
			$('.email_advocacy_specific_legislator_legislation_title').show()

			$('#specific-members-email-advocacy').show()
			$('#auto-members-email-advocacy').hide()
			$('.upper-chamber-subject-lines').hide()
			$('.lower-chamber-subject-lines').hide()

			$('.notice').hide()
		}

		this.showAdditionalEmailsEmailPartsStep()
	}

	showDelaySendingFields(delaySending) {
		if (delaySending) {
			$('.delay-until-container').slideDown()
		} else {
			$('.delay-until-container').slideUp()
		}
	}

	showUserCommentFields(allowComments) {
		if (allowComments) {
			$('.allow-comments-container').slideDown()
		} else {
			$('.allow-comments-container').slideUp()
		}
	}

	showRedirectionFields(redirectAfterSubmission) {
		if (redirectAfterSubmission) {
			$('.email_advocacy_thank_you_content').slideUp()
			$('.email_advocacy_redirect_url').slideDown()
		} else {
			$('.email_advocacy_thank_you_content').slideDown()
			$('.email_advocacy_redirect_url').slideUp()
		}
	}

	showAdditionalEmailsEmailPartsStep() {
		for (let i = 0; i < this.additionalEmailTypeTargets.length; i++) {
			let emailType = this.additionalEmailTypeTargets[i]

			if (emailType.options[emailType.selectedIndex].value == "custom") {
				$('.additional-emails-email-parts-step').show()
				$('.email_advocacy_specific_legislator_legislation_title').show()
				$('#addtional-email-subject-lines').show()
				return;
			} else {
				$('.additional-emails-email-parts-step').hide()
				$('#addtional-email-subject-lines').hide()
			}
		}
	}
}